var __rest =
  (this && this.__rest) ||
  function (s, e) {
    var t = {};
    for (var p in s)
      if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === 'function')
      for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (
          e.indexOf(p[i]) < 0 &&
          Object.prototype.propertyIsEnumerable.call(s, p[i])
        )
          t[p[i]] = s[p[i]];
      }
    return t;
  };
import React from 'react';
import { ALERT, ITEMS } from '../../constants';
import classes from '../../utils/classes';
import withMemoRef from '../../utils/withMemoRef';
/**
 * AlertItems component.
 *
 * @param props AlterItems properties.
 */
export const AlertItems = withMemoRef('AlertItems', (_a, ref) => {
  var { className } = _a,
    props = __rest(_a, ['className']);
  return React.createElement(
    'div',
    Object.assign(
      { className: classes([ALERT, ITEMS], className) },
      Object.assign(Object.assign({}, props), { ref })
    )
  );
});
export default AlertItems;
